var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLifepointsIconAnimated = function SvgLifepointsIconAnimated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "lifepoints-icon-animated_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 50 50"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "lifepoints-icon-animated_svg__defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".lifepoints-icon-animated_svg__cls-1{fill:#f15e22}.lifepoints-icon-animated_svg__cls-2{fill:#f99d1c}.lifepoints-icon-animated_svg__cls-3{fill:#fed401}.lifepoints-icon-animated_svg__cls-4{fill:#b4d334}.lifepoints-icon-animated_svg__cls-5{fill:#63c29d}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lifepoints-icon-animated_svg__g943"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle8",
    cx: 25.24,
    cy: 3.66,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle20",
    cx: 17.93,
    cy: 4.95,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-20 17.928 4.945)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle32",
    cx: 11.5,
    cy: 8.66,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-40 11.5 8.666)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle44",
    cx: 6.73,
    cy: 14.35,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-60 6.728 14.346)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle56",
    cx: 4.19,
    cy: 21.33,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-80 4.19 21.327)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle68",
    cx: 4.19,
    cy: 28.75,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-10 4.164 28.755)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle80",
    cx: 6.73,
    cy: 35.73,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-30 6.723 35.741)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle92",
    cx: 11.5,
    cy: 41.42,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-50 11.506 41.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle104",
    cx: 17.94,
    cy: 45.13,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-70 17.935 45.133)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle116",
    cx: 25.25,
    cy: 46.42,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle128",
    cx: 32.55,
    cy: 45.13,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-20 32.567 45.126)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle140",
    cx: 38.98,
    cy: 41.41,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-40 38.987 41.415)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle152",
    cx: 43.75,
    cy: 35.72,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-60 43.75 35.721)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle164",
    cx: 46.29,
    cy: 28.75,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-80 46.288 28.747)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle176",
    cx: 46.29,
    cy: 21.32,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-10 46.278 21.325)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle188",
    cx: 43.75,
    cy: 14.34,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "matrix(.87 -.5 .5 .87 -1.31 23.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle200",
    cx: 38.98,
    cy: 8.66,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-50 38.976 8.658)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle212",
    cx: 32.55,
    cy: 4.94,
    r: 2.34,
    className: "lifepoints-icon-animated_svg__cls-1",
    transform: "rotate(-70 32.55 4.945)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "lifepoints-icon-animated_svg__g923"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle10",
    cx: 25.24,
    cy: 8.97,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle22",
    cx: 19.75,
    cy: 9.94,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-20 19.737 9.942)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle34",
    cx: 14.91,
    cy: 12.73,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-40 14.91 12.723)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle46",
    cx: 11.33,
    cy: 17,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "matrix(.5 -.87 .87 .5 -9.06 18.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle58",
    cx: 9.42,
    cy: 22.25,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-80 9.417 22.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle70",
    cx: 9.42,
    cy: 27.83,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-10 9.428 27.833)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle82",
    cx: 11.33,
    cy: 33.08,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-30 11.337 33.078)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle94",
    cx: 14.92,
    cy: 37.35,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-50 14.92 37.347)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle106",
    cx: 19.75,
    cy: 40.14,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-70 19.752 40.137)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle118",
    cx: 25.25,
    cy: 41.11,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle130",
    cx: 30.74,
    cy: 40.14,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-20 30.73 40.124)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle142",
    cx: 35.57,
    cy: 37.35,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-40 35.57 37.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle154",
    cx: 39.15,
    cy: 33.07,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-60 39.152 33.066)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle166",
    cx: 41.06,
    cy: 27.82,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-80 41.061 27.824)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle178",
    cx: 41.06,
    cy: 22.24,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-10 41.071 22.252)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle190",
    cx: 39.16,
    cy: 16.99,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "matrix(.87 -.5 .5 .87 -3.25 21.85)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle202",
    cx: 35.56,
    cy: 12.72,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-50 35.567 12.721)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle214",
    cx: 30.73,
    cy: 9.93,
    r: 1.87,
    className: "lifepoints-icon-animated_svg__cls-2",
    transform: "rotate(-70 30.73 9.929)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lifepoints-icon-animated_svg__g903"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle12",
    cx: 25.24,
    cy: 13.52,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle24",
    cx: 21.3,
    cy: 14.21,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-20 21.292 14.222)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle36",
    cx: 17.84,
    cy: 16.21,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-40 17.838 16.216)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle48",
    cx: 15.27,
    cy: 19.28,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-60 15.267 19.276)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle60",
    cx: 13.9,
    cy: 23.04,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-80 13.903 23.039)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle72",
    cx: 13.9,
    cy: 27.04,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-10 13.876 27.013)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle84",
    cx: 15.27,
    cy: 30.8,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-30 15.264 30.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle96",
    cx: 17.84,
    cy: 33.86,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-50 17.836 33.864)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle108",
    cx: 21.31,
    cy: 35.86,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-70 21.308 35.863)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle120",
    cx: 25.25,
    cy: 36.56,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle132",
    cx: 29.18,
    cy: 35.86,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-20 29.17 35.873)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle144",
    cx: 32.65,
    cy: 33.86,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-40 32.65 33.866)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle156",
    cx: 35.21,
    cy: 30.79,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-60 35.212 30.791)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle168",
    cx: 36.58,
    cy: 27.03,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-80 36.58 27.029)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle180",
    cx: 36.58,
    cy: 23.03,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "matrix(.98 -.17 .17 .98 -3.44 6.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle192",
    cx: 35.21,
    cy: 19.27,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-30 35.215 19.276)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle204",
    cx: 32.64,
    cy: 16.21,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-50 32.635 16.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle216",
    cx: 29.17,
    cy: 14.21,
    r: 1.5,
    className: "lifepoints-icon-animated_svg__cls-3",
    transform: "rotate(-70.1 29.122 14.235)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "lifepoints-icon-animated_svg__g883"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle14",
    cx: 25.24,
    cy: 17.39,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle26",
    cx: 22.63,
    cy: 17.85,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-20 22.612 17.846)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle38",
    cx: 20.33,
    cy: 19.18,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-40 20.324 19.174)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle50",
    cx: 18.62,
    cy: 21.21,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "matrix(.5 -.87 .87 .5 -9.06 26.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle62",
    cx: 17.71,
    cy: 23.71,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-80 17.716 23.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle74",
    cx: 17.71,
    cy: 26.37,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-10 17.733 26.372)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle86",
    cx: 18.62,
    cy: 28.87,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-30 18.624 28.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle98",
    cx: 20.33,
    cy: 30.9,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-50 20.328 30.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle110",
    cx: 22.63,
    cy: 32.23,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-70 22.632 32.225)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle122",
    cx: 25.25,
    cy: 32.69,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle134",
    cx: 27.86,
    cy: 32.22,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-20 27.855 32.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle146",
    cx: 30.16,
    cy: 30.9,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-40 30.155 30.889)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle158",
    cx: 31.86,
    cy: 28.86,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-60 31.86 28.856)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle170",
    cx: 32.77,
    cy: 26.36,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-80 32.767 26.358)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle182",
    cx: 32.77,
    cy: 23.7,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-10 32.766 23.713)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle194",
    cx: 31.86,
    cy: 21.21,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "matrix(.87 -.5 .5 .87 -6.33 18.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle206",
    cx: 30.15,
    cy: 19.18,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-50 30.154 19.178)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle218",
    cx: 27.85,
    cy: 17.85,
    r: 1.08,
    className: "lifepoints-icon-animated_svg__cls-4",
    transform: "rotate(-70 27.85 17.841)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "lifepoints-icon-animated_svg__g863"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle16",
    cx: 25.24,
    cy: 20.58,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle28",
    cx: 23.72,
    cy: 20.85,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-20 23.72 20.848)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle40",
    cx: 22.38,
    cy: 21.62,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-40 22.375 21.617)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle52",
    cx: 21.39,
    cy: 22.81,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-60 21.39 22.811)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle64",
    cx: 20.86,
    cy: 24.27,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-80 20.857 24.264)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle76",
    cx: 20.86,
    cy: 25.81,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-10 20.832 25.837)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle88",
    cx: 21.38,
    cy: 27.27,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-30 21.392 27.272)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle100",
    cx: 22.38,
    cy: 28.45,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-50 22.383 28.452)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle112",
    cx: 23.72,
    cy: 29.23,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-70 23.718 29.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle124",
    cx: 25.25,
    cy: 29.5,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle136",
    cx: 26.77,
    cy: 29.23,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-20 26.775 29.223)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle148",
    cx: 28.11,
    cy: 28.45,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-40 28.104 28.446)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle160",
    cx: 29.1,
    cy: 27.26,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-60 29.098 27.261)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle172",
    cx: 29.63,
    cy: 25.81,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-80 29.627 25.804)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle184",
    cx: 29.63,
    cy: 24.26,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-10 29.61 24.243)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle196",
    cx: 29.1,
    cy: 22.8,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-30 29.092 22.795)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle208",
    cx: 28.1,
    cy: 21.62,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-50 28.103 21.616)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle220",
    cx: 26.76,
    cy: 20.84,
    r: 0.64,
    className: "lifepoints-icon-animated_svg__cls-5",
    transform: "rotate(-70 26.759 20.844)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lifepoints-icon-animated_svg__g1516"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle16-1",
    cx: 25.242,
    cy: 23.057,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle28-8",
    cx: 15.158,
    cy: 30.181,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-20)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle40-7",
    cx: 3.246,
    cy: 33.424,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-40)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle52-9",
    cx: -9.062,
    cy: 32.402,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-60)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle64-2",
    cx: -20.273,
    cy: 27.23,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-80)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle76-0",
    cx: 18.531,
    cy: 29.04,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-10)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle88-2",
    cx: 7.357,
    cy: 34.31,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-30)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle100-3",
    cx: -4.937,
    cy: 35.433,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-50)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle112-7",
    cx: -16.878,
    cy: 32.286,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-70)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle124-5",
    cx: 25.247,
    cy: 27.023,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle136-9",
    cx: 15.159,
    cy: 34.148,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-20)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle148-2",
    cx: 3.246,
    cy: 37.388,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-40)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle160-2",
    cx: -9.061,
    cy: 36.36,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-60)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle172-8",
    cx: -20.271,
    cy: 31.19,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-80)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle184-9",
    cx: 22.495,
    cy: 29.039,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-10)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle196-7",
    cx: 11.327,
    cy: 34.301,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-30)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle208-3",
    cx: -0.973,
    cy: 35.431,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-50)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lifepoints-icon-animated_svg__circle220-6",
    cx: -12.912,
    cy: 32.279,
    r: 0.285,
    className: "lifepoints-icon-animated_svg__cls-5",
    style: {
      fill: "#5bc7d4",
      fillOpacity: 1,
      strokeWidth: 0.444708
    },
    transform: "rotate(-70)"
  })));
};
export default SvgLifepointsIconAnimated;